import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["panelColors", "leftPad", "topPad", "rectY", "space", "rectSize", "legendCellSize", "legendRender"];
import React, { Fragment, useMemo, createElement as _createElement } from 'react';
import { Rect } from "./Rect.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Legend(_ref) {
  var panelColors = _ref.panelColors,
    _ref$leftPad = _ref.leftPad,
    leftPad = _ref$leftPad === void 0 ? 0 : _ref$leftPad,
    _ref$topPad = _ref.topPad,
    topPad = _ref$topPad === void 0 ? 0 : _ref$topPad,
    _ref$rectY = _ref.rectY,
    rectY = _ref$rectY === void 0 ? 15 : _ref$rectY,
    _ref$space = _ref.space,
    space = _ref$space === void 0 ? 0 : _ref$space,
    _ref$rectSize = _ref.rectSize,
    rectSize = _ref$rectSize === void 0 ? 0 : _ref$rectSize,
    _ref$legendCellSize = _ref.legendCellSize,
    legendCellSize = _ref$legendCellSize === void 0 ? 0 : _ref$legendCellSize,
    legendRender = _ref.legendRender,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var size = legendCellSize || rectSize;
  return useMemo(() => /*#__PURE__*/_jsx(Fragment, {
    children: Object.keys(panelColors || {}).map((num, key) => {
      var rectProps = _extends({}, props, {
        key,
        x: (size + 1) * key + leftPad,
        y: rectY,
        // y: topPad + rectSize * 8 + 6,
        fill: panelColors[Number(num)],
        width: size,
        height: size
      });
      if (legendRender) return legendRender(rectProps);
      return /*#__PURE__*/_createElement(Rect, _extends({}, rectProps, {
        key: key
      }));
    })
  }), [panelColors, props, size, rectY, leftPad, rectSize, legendRender]);
}